import React, { useState } from "react";
import { IconType } from "react-icons";
import { useNavigate, useLocation } from "react-router-dom";
import { FaChevronDown, FaChevronRight } from "react-icons/fa";
import "./sidebaritems.scss";

interface SubItem {
  icon: IconType;
  text: string;
  path: string;
}

interface Props {
  Icon: IconType;
  text: string;
  subItems: SubItem[];
}

const SidebarExpandableItem = ({ Icon, text, subItems }: Props) => {
  const location = useLocation();
  const navigate = useNavigate();
  
  // Check if any sub-item is active
  const isAnySubItemActive = subItems.some(item => location.pathname === item.path);
  const [isExpanded, setIsExpanded] = useState(isAnySubItemActive);

  const toggleExpand = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <div className="sidebar_expandable">
      <div 
        className={`component_sidebaritems expandable ${isAnySubItemActive ? "active" : ""}`} 
        onClick={toggleExpand}
      >
        <div className="sidebar_icon">
          <Icon size={"20px"}/>
        </div>
        <span className="sidebar_text">{text}</span>
        <div className="sidebar_chevron">
          {isExpanded ? <FaChevronDown size={12} /> : <FaChevronRight size={12} />}
        </div>
      </div>
      
      {isExpanded && (
        <div className="sidebar_subitems">
          {subItems.map((item, i) => {
            const isSubActive = location.pathname === item.path;
            return (
              <div 
                key={i}
                className={`sidebar_subitem ${isSubActive ? "active" : ""}`}
                onClick={() => navigate(item.path)}
              >
                <div className="subitem_icon">
                  <item.icon size={"16px"}/>
                </div>
                <span className="subitem_text">{item.text}</span>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default SidebarExpandableItem;
